import { useEffect } from 'react';
import { reactPlugin } from './AppInsights';

export function useErrorTracking() {
  const loggedErrors = new Set();

  useEffect(() => {
    const originalConsoleError = console.error;

    function customConsoleError(...args) {
      originalConsoleError.apply(console, args);
      const joinedArgs = 'ConsoleError: ' + args.join(' ');
      loggedErrors.add(joinedArgs);
      reactPlugin.trackException({ error: joinedArgs });
    }

    console.error = customConsoleError;

    return () => {
      console.error = originalConsoleError;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    function globalErrorListener(event) {
      const errorString = 'EventError: ' + event.error.toString();
      if (!loggedErrors.has(errorString)) {
        reactPlugin.trackException({ error: errorString });
      }
    }
    window.addEventListener('error', globalErrorListener);

    return () => {
      window.removeEventListener('error', globalErrorListener);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
